<template>
  <b-modal
    id="modal-clock-in"
    ref="modal-clock-in"
    :title="$t('gmapLocation.clockIn.installationLocation')"
    size="lg"
    centered
    modal-class="mc-modal-clock-in-photo"
  >
    <div class="mc-modal-clock-in-photo__wrapper">
      <img :src="clockInData.clock_in_photo" :alt="`clock-in-${clockInData.wo_number}`" />
    </div>
    <div class="w-100 text-center">
      <p class="my-2">{{ clockInData.clock_in_address ? clockInData.clock_in_address : $t('gmapLocation.clockIn.locationUnknown') }}</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    clockInData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hideModalClockInPhoto() {
      this.$bvModal.hide('modal-clock-in')
    },
  },
}
</script>
